import script from "./MerchantListPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantListPanel.vue?vue&type=script&setup=true&lang=js"

import "./MerchantListPanel.vue?vue&type=style&index=0&id=180a531c&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180a531c"]])

export default __exports__